<template>
  <div>
    <div class="modal-card be-card" scroll="keep">
      <div class="modal-card-head be-modal-card-head">
        <div class="container">
          <div class="columns is-mobile topHalf">
            <div class="column is-two-thirds">
              <h1 class="be-modal-title">
                {{ $t("business_structures") }}
              </h1>
            </div>
            <div class="column is-one-third exitButton">
              <b-button
                class="be-nav-button is-pulled-right"
                outlined
                type="is-light"
                :aria-label="$t('close')"
                @click="$parent.close()"
              >
                <font-awesome-icon :icon="['fas', 'times']" />
                {{ $t("close") }}
              </b-button>
              <b-button
                v-if="this.sgc == '13' || this.sgc == '46'"
                class="be-nav-button is-pulled-right"
                outlined
                type="is-light"
                :aria-label="$t('toggle_lang')"
                @click="changeLang(langLocal)"
              >
                {{ $t("toggle_lang") }}
              </b-button>
            </div>
          </div>
          <div class="columns be-subheader">
            <div class="column auto"></div>
            <div class="column is-one-half be-subheader">
              <!-- <div class="column  is-four-fifths is-pulled-right "> -->
              <div v-if="started">
                <b-tooltip
                  type="is-light"
                  :label="$t('entity_tooltip')"
                  multilined
                  position="is-top"
                >
                  <div>
                    <h2 class="subtitle be-subtitle is-5">
                      {{ $t("entity_title_one") }}
                    </h2>
                    <h3 class="subtitle be-subtitle is-4">
                      {{ $t("entity_title_two") }}
                    </h3>
                  </div>
                </b-tooltip>
              </div>

              <div v-if="!started">
                <h2
                  class="subtitle be-subtitle is-5"
                  style="visibility: hidden"
                >
                  Placeholder
                </h2>
                <h3
                  class="subtitle be-subtitle is-4"
                  style="visibility: hidden"
                >
                  Placeholder
                </h3>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-card-body be-modal-card-body">
        <div v-if="!started">
          <BaseCard :lang="this.langLocal" class="be-summary box">
            <template v-slot:headertext>
              <h2 v-if="welcomeGate" class="title be-results-title">
                {{ $t("welcome") }}
              </h2>
            </template>
            <template v-slot:bodytext>
              <div v-if="welcomeGate">
                <p>{{ $t("intro_1") }}</p>
                <p>{{ $t("intro_2") }}</p>
                <p>{{ dataSummary[`intro_3_${langLocal}`] }}</p>
                <p>{{ $t("intro_4") }}</p>
                <p>
                  {{ $t("intro_5")
                  }}<a class="be-link" @click="printSummaries">
                    {{ $t("here") }}</a
                  >{{ $t("intro_6") }}
                </p>
                <b-button class="be-start-button" @click="start()">
                  {{ $t("start") }}</b-button
                >
              </div>
            </template>
            <template v-slot:footertext>
              <section v-if="welcomeGate" class="be-disclaimer">
                <p
                  v-html="$t(dataSummary[`disclaimer_welcome_${langLocal}`])"
                ></p>
              </section>
            </template>
          </BaseCard>
        </div>
        <div v-if="started">
          <Entity
            @clicked="restartEntity"
            :lang="this.langLocal"
            :sgc="this.sgcLocal"
            :data="this.dataLocal"
          ></Entity>
        </div>
      </div>

      <footer class="modal-card-foot be-modal-card-foot">
        <p class="is-pulled-right">
          <span v-if="welcomeGate">
            <img
              class="be-footer-logo"
              :src="getImage(dataSummary)"
              :alt="getAltText(dataSummary)"
            />
          </span>

          <b-tooltip
            v-if="!welcomeGate"
            class="be-tooltip"
            multilined
            role="tooltip"
            :triggers="['focus', 'hover']"
          >
            <template v-slot:content>
              {{
                $t("tooltip_disclaimer", {
                  contact_name: dataSummary[`contact_name_${langLocal}`]
                })
              }}
            </template>
            <span tabindex="0">{{ $t("disclaimer_title") }}</span>
          </b-tooltip>
          <span v-if="started"> | </span>

          <a
            v-if="started"
            class="be-link"
            target="_blank"
            rel="noopener"
            :href="$t('support_link')"
            >{{ $t("support") }}</a
          >
          <span v-if="!welcomeGate"> | </span>
          <span>
            {{ $t("powered") }}
            <a
              class="be-link"
              target="_blank"
              rel="noopener"
              :href="$t('bizpal_link')"
              >{{ $t("bizpal") }}</a
            >
          </span>
        </p>
      </footer>
    </div>
    <b-modal
      :active.sync="isSummariesModalActive"
      :can-cancel="canCancel"
      full-screen
      aria-role="dialog"
      aria-modal
      class="be-print-modal"
    >
      <ModalSummary
        :lang="this.langLocal"
        @clicked="closeModal()"
        :data="dataSummary"
        :sgc="this.sgcLocal"
      >
      </ModalSummary>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import BaseCard from "@/components/base-components/BaseCard.vue";
import Entity from "@/components/Entity.vue";
import ModalSummary from "./ModalSummary.vue";
import interaction from "@bizpal/open-services-interaction-mixins";

import VueI18nHome from "vue-i18n";
Vue.use(VueI18nHome);

// Create VueI18n instance with options
export const i18n = new VueI18nHome({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en"
});

export default {
  name: "ModalHome",
  components: {
    BaseCard,
    Entity,
    ModalSummary
  },
  i18n: {
    locale: "en",
    messages: {
      en: {
        business_structures: "Business Structures Wizard",
        welcome: "Welcome",
        close: "Exit",
        restart: "Restart",
        start: "Start",
        entity_title_one: "Suggested",
        entity_title_two: "Business Structure",
        disclaimer_title: "Disclaimer",
        tooltip_disclaimer:
          "This tool is intended as general guidance and not as legal or financial advice. Please seek the services of a lawyer and accountant or get advice from {contact_name} before making your decision.",
        powered: "Powered by",
        bizpal_link: "https://services.bizpal-perle.ca/",
        bizpal: "BizPaL",
        intro_1:
          "One of your first decisions when creating a new organization is your legal structure, or entity type. Each type has advantages and disadvantages.",
        intro_2:
          "Use this tool to compare different business structure options and help you determine which one may be the best fit for your business.",
        intro_4: "Pick the answers that best fit your business.",
        intro_5: "You can also read a ",
        here: "summary of all business structures",
        intro_6: ".",
        entity_tooltip:
          "Watch these progress bars change to see how your answers affect your best match.",
        support_link: "mailto:open@bizpal-perle.ca",
        support: "Support",
        toggle_lang: "FR"
      },

      fr: {
        business_structures: "Assistant de structures d'entreprise",
        welcome: "Bienvenue",
        close: "Quitter",
        restart: "Redémarrer",
        start: "Commencer",
        entity_title_one: "Structure d'entreprise",
        entity_title_two: "suggérée",
        disclaimer_title: "Avertissement",
        tooltip_disclaimer:
          "Cet outil est destiné comme lignes directrices générales et non pas un avis légal ou financier. Veuillez chercher les services d'avocat et de comptable ou obtenez un avis de {contact_name} avant de prendre votre décision.",
        powered: "Proposé par",
        bizpal_link: "https://services.perle-bizpal.ca/",
        bizpal: "PerLE",
        intro_1:
          "Une de vos premières décisions lors de la création d'une nouvelle entreprise est votre structure ou forme juridique. Chaque type a des avantages et des désavantages.",
        intro_2:
          "Utilisez cet outil pour comparer les structures d'entreprise et vous aider à déterminer la forme qui convient le mieux à votre entreprise.",
        intro_4:
          "Choisissez les réponses qui se rapproche le mieux à votre entreprise.",
        intro_5: "Vous pouvez aussi lire ",
        here: "un sommaire de toutes les structures d'entreprise",
        intro_6: ".",
        entity_tooltip:
          "Observez l'effet de vos choix de réponses sur le résultat de ces barres de progression.",
        support_link: "mailto:ouverts@perle-bizpal.ca",
        support: "Soutien",
        toggle_lang: "EN"
      }
    }
  }, // end i18n
  props: {
    lang: {
      type: String,
      default: "en"
    },
    sgc: {
      type: String
    },
    data: {
      type: Object
    }
  },
  mixins: [interaction],
  data: function() {
    return {
      radioButton: "",
      started: false,
      langLocal: this.lang,
      welcomeGate: true,
      sgcLocal: this.sgc,
      dataLocal: this.data,
      isSummariesModalActive: false,
      canCancel: false
    };
  },
  created: function() {
    this.dataSummary = this.dataLocal[`pid-${this.sgcLocal}`];
  },
  mounted: function() {
    this.$i18n.locale = this.langLocal;
  },
  watch: {
    lang: function() {
      this.$i18n.locale = this.langLocal;
    }
  },
  methods: {
    saveInteraction: function(action, value) {
      let propsInteraction = this.mxGetDefaultInteractionProp(
        this.langLocal,
        "Business Structure - Widget"
      );
      propsInteraction.hostname =
        window.location != window.parent.location
          ? document.referrer
          : document.location.href;
      propsInteraction.branding = `${this.sgcLocal}`;
      let statementInteraction = this.mxCreateNodeStatement(
        "n",
        this.mxInteraction.label,
        propsInteraction
      );

      // Create Node Events

      let propsEvents = {};
      propsEvents.action = action;
      propsEvents.label = value;
      let statementEvents = this.mxCreateNodeStatement(
        "e",
        "Events",
        propsEvents
      );

      // create Merge relationship Interaction and UserDate
      let statementRelationshipDate = this.mxCreateDateMergeRelationshipDate(
        propsInteraction.key,
        propsInteraction.timestamp_readable
      );

      let statementRelationshipEvents = this.mxCreateInteractionRelationshipStatement(
        this.mxInteraction.label,
        propsInteraction.key,
        "INTERACT_WITH_CONTEXT",
        "Events",
        "timestamp",
        [propsEvents.timestamp],
        false
      );

      this.mxSaveInteraction(
        process.env.VUE_APP_NEO4J_URL,
        process.env.VUE_APP_NEO4J_U,
        process.env.VUE_APP_NEO4J_P,
        [
          statementInteraction,
          statementEvents,
          statementRelationshipEvents,
          statementRelationshipDate
        ]
      );
    },
    start: function() {
      this.$gtag.customMap({ dimension1: "sgc" });
      this.$gtag.event("wizard-started", {
        event_category: "business-entity-tool",
        event_label: "The Wizard has been started",
        sgc: this.sgcLocal,
        product: process.env.VUE_APP_PRODUCT,
        event_lang: this.$i18n.locale
      });

      this.saveInteraction("wizard-started", "The Wizard has been started");
      this.started = true;
      this.welcomeGate = false;
    },
    changeLang: function(langLocal) {
      if (langLocal == "en") {
        this.langLocal = "fr";
        this.$i18n.locale = "fr";
      } else {
        this.langLocal = "en";
        this.$i18n.locale = "en";
      }
      return this.langLocal, this.$i18n.locale;
    },
    getImage(dataSummary) {
      let langLocal = this.langLocal;
      return require("../assets/" + dataSummary[`image_link_${langLocal}`]);
    },
    getAltText(dataSummary) {
      let langLocal = this.langLocal;
      return dataSummary[`prov_name_${langLocal}`] + " Logo";
    },

    // reset form
    reset: function() {
      this.started = false;
    },
    // restart from entity card
    restartEntity(value) {
      if (value == false) {
        this.started = value;
        this.welcomeGate = true;
      }
      if (value == true) {
        this.started = false;
        this.welcomeGate = value;
      }
    },
    printSummaries: function() {
      this.isSummariesModalActive = true;
    },
    closeModal(value) {
      this.isSummariesModalActive = value;
    }
  } //end methods
};
</script>

<style></style>
